import React from "react";

export default function BwossyLogo() {
  return (
      <svg
      className="svg-logo"
        viewBox="0 0 170 170"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="layer1" transform="translate(-53.096972,-46.105011)">
        {/* Background circle */}
        <circle
            id="path1265-7"
            className="svg-logo-background"
            cx="138.09701"
            cy="131.105"
            r="85"        
        />
          {/* Paw */}
          <path
            id="rect835"
            d="m 81.09697,110.89725 h 50 v 50 H 94.326137 A 13.229167,13.229167 45 0 1 81.09697,147.66808 Z"
            transform="translate(15.370911,12.354165)"
          />
          <circle
            id="path918"
            r="25"
            cy="56.571663"
            cx="155.30757"
            transform="matrix(1,0,0,-1,-33.839668,180.35217)"
          />
          <circle
            id="path918-8"
            r="25"
            cy="56.571663"
            cx="155.30757"
            transform="matrix(0,1,1,0,89.367071,-7.0561665)"
          />

          {/* Toe beans */}
          <circle
            id="path1375"
            cx="142.20068"
            cy="-29.580946"
            r="11"
            transform="rotate(45)"
          />
          <circle
            id="path1375-8"
            cx="179.25882"
            cy="-13.741188"
            r="14"
            transform="matrix(0.81832314,0.57475842,-0.53359546,0.84573985,0,0)"
          />
          <circle
            id="path1375-7"
            cx="207.8938"
            cy="-44.328899"
            r="14"
            transform="rotate(45)"
          />
          <circle
            id="path1375-0"
            cx="239.24033"
            cy="-29.581198"
            r="11"
            transform="rotate(45)"
          />
        </g>
      </svg>
  );
}